// import { HasPermission } from '../../Helper/Permisstions/Permisstions';

const fleetMenu = [
  {
    System: 'FLEET',
    isActive: false,
    menu: [
      { is_header: true, title: 'FleetManagement', isActive: true },
  

      {
        path: '/FLEET/HomePage',
        icon: 'fas fa-home',
        title: 'HomePage',
        isActive: true
      },

      { is_header: true, title: 'Operations', isActive: true },

      {
        path: '/FLEET/Equipments',
        icon: 'fas fa-fw fa-car',
        title: 'Vehicles',
        permission: 'FleetEquipmentList',
        isActive: true
      },

      {
        path: '/FLEET/HandOver',
        icon: 'fas fa-handshake',
        title: 'Handover',
        permission: 'FleetAddHandover',
        isActive: true
      },
      {
        path: '/FLEET/TakeOver',
        icon: 'fas fa-user-check',
        title: 'Takeover',
        permission: 'FleetAddTakeover',
        isActive: true
      },

      {
        path: '/FLEET/EquipmentInspection',
        icon: 'bi bi-gear-wide-connected',
        title: 'EquipmentInspection',
        permission: 'FleetScanEquipmentList',
        isActive: true
      },
      {
        path: '/FLEET/WorkOrder',
        icon: 'bi bi-tools',
        title: 'MaintenanceOrders',
        permission: 'FleetViewListMaintenanceOrders',
        isActive: true
      },

      { is_header: true, title: 'Settings', isActive: true },

      {
        path: '/FLEET/Settings/Manufacturers',
        title: 'Manufacturers',
        icon: 'bi bi-building', // Represents factories or manufacturers
        permission: 'FleetViewListManufacturers',
        isActive: true
      },

      {
        path: '/FLEET/Settings/Model',
        title: 'Model',
        icon: 'bi bi-car-front', // Represents car models
        permission: 'FleetViewModelList',
        isActive: true
      },

      {
        path: '/FLEET/Settings/FleetElementScan',
        title: 'InspectionItems',
        icon: 'bi bi-clipboard-check', // Represents inspection tasks
        permission: 'FleetViewListScanItems',
        isActive: true
      },

      {
        path: '/FLEET/Settings/WorkShop',
        title: 'Workshops',
        icon: 'bi bi-tools', // Represents workshops or repair tools
        permission: 'FleetViewListWorkshops',
        isActive: true
      },

      {
        path: '/FLEET/Settings/Locations',
        title: 'Locations',
        icon: 'bi bi-geo-alt', // Represents locations or places
        permission: 'FleetViewListLocations',
        isActive: true
      },

      {
        path: '/FLEET/Settings/Suppliers',
        title: 'Suppliers',
        icon: 'bi bi-truck', // Represents suppliers delivering goods
        permission: 'FleetViewSuppliersList',
        isActive: true
      },

      {
        path: '/FLEET/Settings/Drivers',
        title: 'Drivers',
        icon: 'bi bi-person-badge', // Represents drivers with ID badges
        permission: 'FleetViewDriversList',
        isActive: true
      },

      {
        path: '/FLEET/Settings/Owners',
        title: 'Owners',
        icon: 'bi bi-person-lines-fill', // Represents ownership records
        permission: 'FleetViewOwnersList',
        isActive: true
      },

      {
        path: '/FLEET/AccountingPeriod',
        title: 'AccountingPeriod',
        icon: 'fas fa-calendar-alt',
        permission: 'FLEETViewAccountingPeriodsList',
        isActive: true
      },

      { is_header: true, title: 'Reports', isActive: true },
      {
        path: '/FLEET/Reports',
        icon: 'bi bi-clipboard2-data-fill',
        title: 'Reports',
        isActive: true
      },
      {
        path: '/FLEET/FleetDashboard',
        icon: 'bi bi-cpu',
        title: 'Dashboard',
        // isActive:false,
        isActive: true
      }
    ]
  }
];

export default fleetMenu;
